// @flow
import React, { type ComponentType } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const Img: ComponentType<*> = styled.img`
  max-width: 100%;
  width: 100%;
  height: 100%;
  border-radius: 5px;
`;

const Logo = () => {
  const logo = useSelector(({ bsn: { user: { profile } } }) => (profile ? profile.logo_partner : null));
  return logo ? <Img src={logo} alt="Logo" /> : null;
};

export default Logo;
